import React, {useMemo} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import Form, {FormInputComponent} from '../../../components/form/Form';
import {Input, Select} from 'antd';
import {useTalentTeam} from "../../../providers/TalentTeamProvider";

const {TextArea} = Input
const {Option} = Select;

const TalentTeamInfoStep = React.forwardRef(({}, formRef) => {
    const {team, isUpdating, onModelChange} = useTalentTeam();
    const navigate = useNavigate();
    const params = useParams();


    // This page is to handle both creating and editing teams

    if (params.teamId) {
        console.log('EDITING PAGE')
    }

    const linkTypes = useMemo(() => {
        let links = TB.map(laravel.talent_profile_link_types || {}, (link, value) => {
            return {
                ...link,
                value: parseInt(value)
            }
        });
        let website = TB.find(links, ['name', 'Website']);
        links.unshift(website);
        return TB.uniqBy(links, 'name')
    }, []);

    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">Team Bio</h3>
                        </div>

                        <h5 className="form-subtitle">
                            Let's create a profile for your team. Please provide key information below.
                        </h5>
                    </div>
                </div>
            </div>

            <div className="talent-role-form">
                <Form
                    ref={formRef}
                    title={null}
                    subtitle={null}
                    showRequired
                    submitButton={false}
                    onChange={(model) => {
                        let updates = {...model}
                        for (let [key, value] of Object.entries(model)) {
                            updates = TB.set(updates, key, value)
                        }
                        onModelChange(updates)
                    }}
                    model={team}
                    fields={[]}
                    isDisabled={false}>

                    <div className="flex flex-col items-stretch">
                        <div className="field-section flex-row items-start">
                            <div className="field px-3.5 basis-10/12">
                                <FormInputComponent
                                    fieldName="bio"
                                    value={team?.bio || ''}
                                    label="Bio"
                                    required={true}
                                    placeholder="Team Bio"
                                    type="editor"
                                    maxLength={10000}
                                    minLength={0}
                                    rows={10}
                                    validation={{
                                        rules: {maxLength: 10000},
                                        errors: {
                                            maxLength: TB.trans('validation.max.string', {
                                                'attribute': 'description',
                                                'max': 10000
                                            }),
                                            minCharLength: 'The team bio field is required.'
                                        }
                                    }}/>

                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col items-stretch">
                        <div className="field-section flex-row items-start">
                            <div className="field px-3.5 basis-10/12">

                                <FormInputComponent
                                    fieldName="banner_image_path"
                                    value={team.banner_image_path}
                                    labelHint="Note: Image will be cropped to 16x9 aspect for display purposes"
                                    type="pixie"
                                    circular={false}
                                    ratio="16:9"
                                    width={400}
                                    shouldResize={true}
                                    disabled={false}
                                    size={team?.banner_image_path?.size}
                                    viewable={typeof team?.banner_image_path === 'string'}
                                    label="Cover Image"
                                    fileNameDisplay={(fileData) => {
                                        if (typeof team?.banner_image_path === 'string') {
                                            return team.banner_image_path?.name || fileData.name;
                                        }
                                        return team?.banner_image_path?.name || fileData.name;
                                    }}
                                />

                            </div>
                        </div>
                    </div>

                    <hr/>

                    <p className="mb-4">
                        Team Profile Links (Website, portfolio, .etc)
                    </p>
                    <div className="flex flex-col items-stretch gap-3">

                        {team.profile_links?.length > 0 && TB.map(team.profile_links, (link, linkIndex) => (
                            <div className="flex flex-row items-center justify-start gap-4" key={`team-link-${linkIndex}`}>
                                <div className="team-links-input flex-grow flex flex-row items-start justify-start gap-2">
                                    <div className="min-w-[185px]">

                                        <FormInputComponent
                                            fieldName={`profile_links[${linkIndex}].type`}
                                            value={link.type || null}
                                            type="antd-input"
                                            required={true}
                                            validateBeforeSubmit={false}
                                            label={false}
                                            placeholder={"Link type"}
                                        >

                                            <Select value={link.type} defaultValue={linkTypes[0]?.value}>

                                                {TB.map(linkTypes, (opt) => (
                                                    <Option key={`opt-${linkIndex}-${opt.name}`} value={opt.value}>
                                                        <span className="flex flex-row items-center gap-2">
                                                            <i className={`${opt.icon.includes('fa-brand') ? 'fab' : 'fas'} fa-${opt.icon}`}
                                                               style={{color: opt.color}}/>
                                                            <span>{opt.name}</span>
                                                        </span>
                                                    </Option>
                                                ))}
                                            </Select>

                                        </FormInputComponent>
                                    </div>

                                    <div className="flex-grow">
                                        <FormInputComponent
                                            fieldName={`profile_links[${linkIndex}].url`}
                                            value={link.url}
                                            type="antd-input"
                                            maxLength={255}
                                            validation={{
                                                rules: {
                                                    matchRegexp: /^(http|https):\/\//,
                                                    isUrl: true,
                                                },
                                                errors: {
                                                    matchRegexp: 'Must start with http(s)://',
                                                    isUrl: TB.trans('validation.active_url', {'attribute': 'link'})
                                                }
                                            }}
                                            validateBeforeSubmit={true}
                                            required={!!link.type}
                                            label={false}
                                            placeholder={TB.trans('talent.profile_link_form.url_label')}
                                        >
                                            <Input disabled={!link.type} maxLength={255} autoComplete={'off'}/>

                                        </FormInputComponent>

                                    </div>
                                    <button type="button" disabled={isUpdating} onClick={async () => {
                                        let links = TB.xorBy([...(team.profile_links || [])], [link], 'display_index');
                                        links = TB.map(links, (l, currentIndex) => {
                                            return {
                                                ...l,
                                                display_index: currentIndex + 1
                                            }
                                        })

                                        await onModelChange({profile_links: links})
                                    }}>
                                        <i className="fas fa-times-circle text-gray"/>
                                    </button>
                                </div>

                            </div>
                        ))}
                    </div>
                    <div className="mt-3">
                        <button type="button" onClick={async () => {
                            let links = [...(team.profile_links || [])];

                            links.push({type: linkTypes[0]?.value, url: '', display_index: links.length + 1});
                            await onModelChange({profile_links: links})
                        }}
                                disabled={isUpdating} className="btn btn-outline-dark">
                            Add a Link
                        </button>
                    </div>
                </Form>


            </div>
        </div>
    )
})

export default TalentTeamInfoStep;